import { KeyboardEvent } from "react";

export const OnEnterKeyDown = (event: KeyboardEvent, triggerFunc:Function) => {
    if (event.key === 'Enter') {
        triggerFunc();
    }
}